import constants from './constants';

const initState = {
  brands: null,
  brandsLoading: false,
  brandsError: null,

  groups: null,
  groupsLoading: false,
  groupsError: null,

  defaultAlarms: null,

  alarmsFields: { next: undefined, results: null },
  alarmsFieldsLoading: false,
  alarmsFieldsError: null,
};

function variablesReducer(state = initState, { type, payload }) {

  switch (type) {

    case constants.VARIABLES_SET_GROUPS:
      return {
        ...state,
        groups: payload,
        groupsLoading: false,
      };

    case constants.VARIBLES_GROUPS_LOADING:
      return {
        ...state,
        groupsLoading: true,
        groupsError: null,
      };

    case constants.VARIABLES_GROUPS_ERROR:
      return {
        ...state,
        groupsError: payload,
        groupsLoading: false,
      };

    case constants.VARIABLES_GROUPS_ADD:
      return {
        ...state,
        groups: [...state.groups, payload],
      };

    case constants.VARIABLES_SET_BRANDS:
      return {
        ...state,
        brands: payload,
        brandsLoading: false,
      };

    case constants.VARIBLES_BRANDS_LOADING:
      return {
        ...state,
        brandsLoading: true,
        brandsError: null,
      };

    case constants.VARIBLES_BRANDS_ERROR:
      return {
        ...state,
        brandsError: payload,
        brandsLoading: false,
      };

    case constants.VARIABLES_SET_DEFAULT_ALARMS:
      return {
        ...state,
        defaultAlarms: payload,
      };

    case constants.VARIABLES_UPDATE_DEFAULT_ALARM:
      return {
        ...state,
        defaultAlarms: payload,
      };

    case constants.ALARMS_FIELDS_ERROR:
      return {
        ...state,
        alarmsFieldsError: payload,
        alarmsFieldsLoading: false,
      };

    case constants.ALARMS_FIELDS_LOADING:
      return {
        ...state,
        alarmsFieldsLoading: true,
        alarmsFieldsError: null,
      };

    case constants.ALARMS_FIELDS_SUCCESS:
      return {
        ...state,
        alarmsFieldsLoading: false,
        alarmsFields: payload,
      };

    case constants.VARIABLES_SET_MAINTENANCE_TYPES:
      return {
        ...state,
        maintenanceTypes: payload,
        maintenanceTypesLoading: false,
      };

    case constants.VARIBLES_MAINTENANCE_TYPES_LOADING:
      return {
        ...state,
        maintenanceTypesLoading: true,
        maintenanceTypesError: null,
      };

    case constants.VARIABLES_MAINTENANCE_TYPES_ERROR:
      return {
        ...state,
        maintenanceTypesError: payload,
        maintenanceTypesLoading: false,
      };

    case constants.VARIABLES_MAINTENANCE_TYPES_ADD:
      return {
        ...state,
        maintenanceTypes: [...state.maintenanceTypes, payload],
      };

    default:
      return state;

  }

}

export default variablesReducer;
